// extracted by mini-css-extract-plugin
export var actionButton = "_l2-t";
export var buttonContainer = "_l2-0";
export var buttonContainer2 = "_l2-1";
export var buttonSection = "_l2-2";
export var details = "_l2-3";
export var dropdownItem = "_l2-5";
export var dropdownItemsContainer = "_l2-4";
export var fileInput = "_l2-r";
export var headerButton = "_l2-6";
export var icon = "_l2-7";
export var input = "_l2-8";
export var macroListItem = "_l2-9";
export var mainContent = "_l2-a";
export var microText = "_l2-b";
export var modal = "_l2-w";
export var optionsButton = "_l2-c";
export var paperclip = "_l2-s";
export var pillContent = "_l2-d";
export var preview = "_l2-e";
export var preview2 = "_l2-f";
export var quillEditor = "_l2-q";
export var selectedMacro = "_l2-g";
export var sidebar = "_l2-h";
export var sidebarHeader = "_l2-j";
export var sidebarList = "_l2-i";
export var sidebarListItem = "_l2-k";
export var sidebarSearch = "_l2-l";
export var snoozeDurationWrapper = "_l2-v";
export var statusPillContainer = "_l2-m";
export var tagsContainer = "_l2-n";
export var unselectedMacro = "_l2-o";
export var variable = "_l2-u";
export var wrapper = "_l2-p";